import { NgClass, NgStyle } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    forwardRef,
    input,
    model,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import type { ControlValueAccessor } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

type TextValue = string;
let inputId = 0;

@Component({
    selector: 'ui-input-textarea',
    standalone: true,
    imports: [NgStyle, NgClass],
    templateUrl: './m020-c020-input-textarea.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputTextareaComponent), multi: true }],
})
export class InputTextareaComponent implements ControlValueAccessor {
    value = model<string>();
    label = input('');
    placeholder = input<string>();
    disabled = model(false);
    readonly = input(false, { transform: booleanAttribute });
    greyPlaceholder = input(false);

    error = input(false, { transform: booleanAttribute });
    errorMsg = input<string>();

    focussed = signal(false);

    errorId = `textarea-errorId-${inputId++}`;
    inputId = `form-input-textarea-${inputId++}`;

    _onChange?: (value: TextValue) => void;
    _onTouch?: () => void;

    writeValue(value: TextValue): void {
        this.value.set(value);
    }
    registerOnChange(fn: (value: TextValue) => void) {
        this._onChange = fn;
    }
    registerOnTouched(fn: () => void) {
        this._onTouch = fn;
    }
    setDisabledState?(isDisabled: boolean) {
        this.disabled.set(isDisabled);
    }

    defaultHeight = input<number | undefined>();

    defaultHeightValue = computed(() => {
        const defaultHeight = this.defaultHeight();
        if (!defaultHeight) {
            return;
        }

        return `${defaultHeight}px`;
    });

    setValue(event: Event) {
        const { value } = event.target as HTMLInputElement;

        this.value.set(value);
        this._onChange?.(value);
    }
}
